const cache = [];

export default function isDeprecated(klass, instead) {
  if (process.env.NODE_ENV !== 'production') {
    if (cache.indexOf(klass) === -1) {
      cache.push(klass);

      console.warn(
        `
          ${klass.displayName || klass.name} is deprecated.
          You should be using ${instead} instead.
        `
      );
    }
  }
}
